import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import ExpertisePage from '@/pages/expertise/page';
import PeoplePage from '@/pages/people/page';
import InsightsPage from '@/pages/insights/page';
import ArticlePage from '@/pages/insights/detail/page';
import ContactPage from '@/pages/contact/page';

const pageRoutes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/expertise', element: <ExpertisePage /> },
  { path: '/people', element: <PeoplePage /> },
  { path: '/insights', element: <InsightsPage /> },
  { path: '/insights/:slug', element: <ArticlePage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default pageRoutes;